import React,{useState,useEffect} from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import {TextAreaInput1, TextInput} from '../../../components/input';
import {BiErrorCircle,BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button';
import { toast } from 'react-hot-toast';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import GoBack from '../../../components/back/GoBack';
import {Select} from 'antd'
import Uploader from '../../../components/Uploader';
import { UploadUserFile } from '../../../services/AuthServices';
import { GetDigitalCardDistributorDetailService, CreateDigitalCardDistributorService, UpdateDigitalCardDistributorService } from '../../../services/admin/DigitalCardDistributorServices';
import { GetBookingSlotService } from '../../../services/class_booking/bookingSlotServices';
import { GetBatchesSlotService } from '../../../services/class_booking/batchesSlotServices';
import { GetFileStandardService } from '../../../services/admin/FileStandardServices';

function DigitalCardDistributorCE() {

  const navigate = useNavigate()  
  const location = useLocation()
  const {state} = useLocation()

  const [data,setdata] = useState({
    name:'',
    email:'',
    phone:'',
    password:'',
    profile_photo:'',
    is_active:false,
    is_verified:false,
    app_access:false,
    address:'',
    sort:''
  })

  useEffect(()=>{
    if(location?.pathname?.split('/')[location?.pathname?.split('/').length - 1] === 'edit'){
      getdata()
    }
  },[])

  const [error,seterror] = useState({
    name:'',
    email:'',
    phone:'',
    password:'',
    profile_photo:'',
    is_active:'',
    is_verified:'',
    app_access:'',
    address:'',
    sort:''
  })

 



  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  
  async function getdata(){
    const response = await GetDigitalCardDistributorDetailService(state)
    let d = response?.data?.datas[0]
    

    setdata({...data,
      name:d?.name,
      email:d?.email,
      phone:d?.phone,
      is_active:d?.is_active,
      is_verified:d?.is_verified,
      app_access:d?.app_access,
      profile_photo:d?.profile_photo,
      address:d?.address,
      sort:d?.sort
    })
  }

  async function submitdata(){
    if(!data.name){
        seterror({...error,name:'This Field is required*'})
    }else if(!data.email){
        seterror({...error,email:'This Field is required*'})
    }else if(!data.phone){
        seterror({...error,phone:'This Field is required*'})
    }else if(data.phone.length !== 10){
        seterror({...error,phone:'Enter a valid 10 digit mobile no*'})
    }else if(!data.sort){
        seterror({...error,sort:'This Field is required*'})
    }else{
         

        
        let send_data = {...data}
      
        if(location.pathname.split('/')[location.pathname.split('/').length - 1] === 'create'){
            const response = await CreateDigitalCardDistributorService(send_data)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 201){
                toast.success("Digital Card Distributor Onboarded Successfully")
                resetform()
            }
        }else{
            const response = await UpdateDigitalCardDistributorService(send_data,state)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 200){
                toast.success("Digital Card Distributor Updated Successfully")
                resetform()
                navigate(-1)
            }
        }
        
    }
  }

  function resetform(){
    setdata({
        name:'',
        email:'',
        phone:'',
        password:'',
        profile_photo:'',
        is_active:false,
        is_verified:false,
        app_access:false,
        address:'',
        sort:''
      })
    seterror({
        name:'',
        email:'',
        phone:'',
        password:'',
        profile_photo:'',
        is_active:'',
        is_verified:'',
        app_access:'',
        address:'',
        sort:''
      })
  }

  async function UploadFile(e,name){
     const fd = new FormData()
      fd.append('file',e)
      const response = await UploadUserFile(fd)
      setdata({...data,profile_photo:response?.data?.data})

    }

  
  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen md:min-h-screen md:overflow-hidden'>
        <div className='md:flex'> 
         <SettingsMenu />
          <div className='px-5 md:w-full'>

          
        <div className='md:flex md:w-full md:min-h-screen md:max-h-screen md:overflow-y-scroll mb-10'>
        <div className='w-full md:border-r md:w-64 md:pr-5 md:pt-5'>
        <GoBack />  

        <h6 className='font-[700] mb-1'>Create/Edit Digital Card Distributor</h6>
          <h6 className='text-[11px] p-2  mb-2 bg-slate-100'>Use the below form to create or update a digital card distributor</h6>
        


        <TextInput 
         label={'Name'}  
         variant="standard"
         name="name"
         type="text"
         error={error.name}
         value={data.name}
         handlechange={handlechange}
         placeholder="Enter your Name"
         />

        <div className="w-full mr-1"> 
        <TextInput 
         label={'Phone'}  
         variant="standard"
         name="phone"
         type="text"
         error={error.phone}
         value={data.phone}
         handlechange={handlechange}
         placeholder="Enter your Phone"
         />
        </div> 

        <div className="w-full mr-1"> 
        <TextInput 
         label={'Email'}  
         variant="standard"
         name="email"
         type="text"
         error={error.email}
         value={data.email}
         handlechange={handlechange}
         placeholder="Enter your email"
         />
        </div> 

         <div className="w-full mr-1"> 
        <TextInput 
         label={'Sort'}  
         variant="standard"
         name="sort"
         type="number"
         error={error.sort}
         value={data.sort}
         handlechange={handlechange}
         placeholder="Enter your sort"
         />
        </div> 

         <div className="w-full mr-1"> 
        <TextAreaInput1 
         label={'Address'}  
         variant="standard"
         name="address"
         type="text"
         error={error.address}
         value={data.address}
         handlechange={handlechange}
         placeholder=""
         />
        </div>   

        <Uploader error={error?.profile_photo} name="profile_photo" required={false} label={'Profile Photo'} image={data?.profile_photo}  setimagefunc={(e)=>{UploadFile(e,'profile_photo');seterror({...error,profile_photo:''})}}  removeimageuploadfunc = {()=>{setdata({...data,profile_photo:''});seterror({...error,profile_photo:''})}} />

        <div  className='flex mt-2 items-center'>
        <div className='flex items-center mt-0 mr-2'>
        {data?.is_verified ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,is_verified:!data.is_verified})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,is_verified:!data.is_verified})}  /> }
        <h6 className="text-[10px] font-[600] ml-1">Is Verified</h6> 
        </div>  
        <div className='flex items-center mt-0 mr-2'>
        {data?.is_active ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,is_active:!data.is_active})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,is_active:!data.is_active})}  /> }
        <h6 className="text-[10px] font-[600] ml-1">Is Active</h6> 
        </div>  


        
        </div>   

        <div className='flex items-center'>
      
        <div className='flex items-center mt-0 mr-2'>
        {data?.app_access ?  <BiCheckboxSquare size={22} className='text-slate-800' onClick={()=>setdata({...data,app_access:!data.app_access})} />  : <BiCheckbox size={22} className='text-slate-300' onClick={()=>setdata({...data,app_access:!data.app_access})}  /> }
        <h6 className="text-[10px] font-[600] ml-1">App Access</h6> 
        </div>

        </div>



         <div className='flex mt-4 pb-5'>
            <ButtonOutlinedAutoWidth btnName={'Back'} onClick={()=>{navigate(-1)}} />
            <div className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Save'} onClick={submitdata} />
            </div>
         </div>
        </div>
       
         </div>
         </div>
         </div>




    </div>
  )
}

export default DigitalCardDistributorCE